export const ForgotPasswordLayout = {
  type: "div",
  style: { backgroundColor: "#ffffff" },
  children: [
    {
      type: "div",
      className: "row justify-content-center align-items-center",
      style: { minHeight: "95vh" },
      children: [
        {
          type: "div",
          className: "p-5",
          style: { backgroundColor: "#00000055", borderRadius: "10px" },
          children: [
            {
              type: "div",
              className: "text-center mb-5",
              style: { width: "100%" },
              children: [
                {
                  type: "img",
                  style: { width: "200px" },
                  altText: "client-logo"
                }
              ]
            },
            {
              type: "form",
              onFinish: "onSubmitForm",
              children: [
                {
                  type: "div",
                  isHide: "isPasswordResetPage",
                  children: [
                    {
                      type: "text",
                      content: "<h6><strong>{{FORGOT_PASSWORD}}</strong></h6>"
                    },
                    {
                      type: "text",
                      className: "mb-4",
                      content: "{{ENTER_EMAIL}}"
                    },
                    {
                      type: "input",
                      rules: [{ required: true, message: "{{PLEASE_ENTER_YOUR}} {{EMAIL}}" }, { type: "email" }],
                      label: "{{EMAIL}}",
                      name: "email",
                      inputConfig: {
                        placeholder: "{{ENTER}} {{EMAIL}}",
                        size: "large"
                      }
                    }
                  ]
                },
                {
                  type: "div",
                  isHide: "!isPasswordResetPage",
                  children: [
                    {
                      type: "text",
                      content: "<h6><strong>Enter New Password</strong></h6>"
                    },
                    {
                      type: "input",
                      variant: "password",
                      rules:[{ required: true, message: "{{PLEASE_ENTER_YOUR}} {{NEW_PASSWORD}}" }],
                      label: "{{NEW_PASSWORD}}",
                      name: "password",
                      inputConfig: {
                        placeholder: "{{ENTER}} {{NEW_PASSWORD}}",
                        size: "large"
                      }
                    },
                    {
                      type: "input",
                      variant: "password",
                      rules:[
                        { required: true, message: "{{PLEASE_ENTER_YOUR}} {{CONFIRM_PASSWORD}}" }, 
                        { equal: "password", message: "{{PASSWORD_DO_NOT_MATCH}}" }
                      ],
                      label: "{{CONFIRM_PASSWORD}}",
                      name: "confirm-password",
                      inputConfig: {
                        placeholder: "{{ENTER}} {{CONFIRM_PASSWORD}}",
                        size: "large"
                      }
                    }
                  ]
                },
                {
                  type: "div",
                  className: "d-flex",
                  children: [
                    {
                      type: "button",
                      size: "large",
                      href: "#/login",
                      className: "custom-color my-3 mr-3",
                      style: { backgroundColor: "$primary", color: "#ffffff", width: "100%", borderColor: "$primary" },
                      children: [
                        {
                          type: "text",
                          content: "<div>{{BACK_TO_LOGIN_PAGE}}</div>"
                        }
                      ]
                    },
                    {
                      type: "button",
                      size: "large",
                      htmlType: "submit",
                      buttonType: "text",
                      className: "custom-color my-3",
                      style: { backgroundColor: "$quaternary", color: "#ffffff", width: "100%" },
                      children: [
                        {
                          type: "text",
                          content: "<div>{{SUBMIT}}</div>"
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      type: "footer",
      style: { minHeight: "5vh" }
    }
  ]
}